import styled from 'styled-components';
import { Modal } from 'antd';
import {
  primaryColor,
  primaryFont, wELight, wMedium,
} from 'Utils/utilsStyle';
import { useSelector, useDispatch } from 'react-redux';
import { selectImgLink, selectPDFLink } from 'Selector/CertificationSelector';
import { useRef } from 'react';
import DownloadCertificateSvg from 'Components/alerts/assets/svg/DownloadCertificateSvg';
import CrossCircle from '../assets/svgIcons/CrossCircle';
import { actions as flurryActions } from 'Slice/HelperSlice';
import { valueToObject } from '../../../Utils/UtilityFunctions';

const Wrapper = styled.div`
  .view-certificate{
    .ant-modal-content {
      .ant-modal-footer {
        button.ant-btn-default{
           display: none;
        }
        button{
          :active,:focus {
            background-color: ${primaryColor} !important;
            color: #fff !important;
          }
          font-family: ${primaryFont};
          font-weight: ${wMedium};
          font-size: 16px;
          line-height: 20px;
          height: 38px;
          .download-btn{
            display: flex;
            align-items: center;
          }
          .separator{
            font-size: 22px;
            margin: 0px 8px 4px 8px;
            font-weight: ${wELight};
          }
        }
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0px;
        height: 70px;
      }
      .ant-modal-body{
        padding: 56px 10px 0px 10px;
        height: 590px;
        img{
          max-height: 100%;
          max-width: 100%;
        }
      }
    }
  }
`;

const ModalStyle = styled(Modal) <{ background: string }>`
  .ant-modal-body {
    background-image: url(${(props) => props.background});
    background-size: cover;
    background-position: center;
    height: 100%;
    width: 100%;
  }
`;

type Props = {
  visible?: boolean;
  setVisible?: () => void;
} & typeof defaultProps;

const defaultProps = {
  visible: false,
  setVisible: {},
};

const ButtonText = function ButtonText() {
  return (
    <span
      className="download-btn"
      role="button"
      tabIndex={0}
    >
      Download Certificate
      <span className="separator">|</span>
      <DownloadCertificateSvg />
    </span>
  );
};

const ViewCertificatePopup = function ViewCertificatePopup(props: Props) {
  const {
    visible, setVisible,
  } = props;
  const dispatch = useDispatch()
  const imgLink = useSelector(selectImgLink);
  const pdfLink = useSelector(selectPDFLink);
  const elementRef = useRef<HTMLDivElement>(null);

  const downloadPdf = function downloadPdf() {
    dispatch(flurryActions.callFlurryEvent(
      valueToObject('certificate_download', 0),
    ));
    if (pdfLink.length) window.open(pdfLink);
  };

  return (
    <Wrapper ref={elementRef}>
      <ModalStyle
        getContainer={elementRef.current || ''}
        visible={visible}
        onCancel={setVisible}
        centered
        destroyOnClose
        maskClosable
        width={825}
        closeIcon={<div className="cross-icon-x"><CrossCircle /></div>}
        wrapClassName="view-certificate"
        okText={<ButtonText />}
        onOk={() => downloadPdf()}
        background={imgLink}
      />
    </Wrapper>
  );
};

ViewCertificatePopup.defaultProps = defaultProps;
export default ViewCertificatePopup;
